import { render, staticRenderFns } from "./Paginas.vue?vue&type=template&id=6e32d4a4&"
import script from "./Paginas.vue?vue&type=script&lang=js&"
export * from "./Paginas.vue?vue&type=script&lang=js&"
import style0 from "../assets/default.styl?vue&type=style&index=0&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports